import CheckoutSuccessPage from "@/features/checkout/containers/checkout-success-page";
import { createFileRoute } from "@tanstack/react-router";

// Inferred path: /checkout/success
export const Route = createFileRoute("/checkout/success")({
  component: CheckoutSuccessPage,
});
